import React from "react";

const PXSvg = ({ width = "40", height = "40", color = "white" }) => {
  return (
    <svg
      width={width + ""}
      height={height + ""}
      class="w-9 h-9 sm:w-auto sm:h-auto"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-v-c48ceddc=""
    >
      <path
        d="M30.4927 22.9647C31.22 23.692 31.22 24.8713 30.4927 25.5987C29.7653 26.326 28.586 26.326 27.8587 25.5987L22.0647 19.8047L22.0653 19.8033L27.8593 25.5973C28.5867 26.3247 28.5867 27.504 27.8593 28.2313C27.132 28.9587 25.9527 28.9587 25.2253 28.2313L23.9087 26.9147L22.592 30.8653L12.0573 20.3307C9.148 17.4213 9.148 12.7053 12.0573 9.79601C14.9667 6.88668 19.6827 6.88668 22.592 9.79601L33.1267 20.3307C33.854 21.058 33.854 22.2373 33.1267 22.9647C32.3993 23.692 31.22 23.692 30.4927 22.9647ZM30.4927 22.9647L24.6987 17.1707"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
      ></path>
      <path
        d="M14.0007 23.656C13.2733 24.3833 12.094 24.3833 11.3667 23.656C10.6393 22.9287 10.6393 21.7493 11.3667 21.022L12.37 20.0187L12.3713 20.0173L13.3747 19.014C14.102 18.2867 15.2813 18.2867 16.0087 19.014C16.736 19.7413 16.736 20.9207 16.0087 21.648M14.0007 23.656L15.004 22.6527M14.0007 23.656C13.2733 24.3833 13.2733 25.5627 14.0007 26.29C14.728 27.0173 15.9073 27.0173 16.6347 26.29M16.6347 26.29L17.638 25.2867M16.6347 26.29C15.9073 27.0173 15.9073 28.1967 16.6347 28.924C17.362 29.6513 18.5413 29.6513 19.2687 28.924M19.2687 28.924L20.272 27.9207M19.2687 28.924C18.5413 29.6513 18.5413 30.8307 19.2687 31.558C19.996 32.2853 21.1753 32.2853 21.9027 31.558L22.906 30.5547L22.9073 30.5533L23.9107 29.55C24.638 28.8227 24.638 27.6433 23.9107 26.916C23.1833 26.1887 22.004 26.1887 21.2767 26.916M21.2767 26.916L20.2733 27.9193M21.2767 26.916C22.004 26.1887 22.004 25.0093 21.2767 24.282C20.5493 23.5547 19.37 23.5547 18.6427 24.282M18.6427 24.282L17.6393 25.2853M18.6427 24.282C19.37 23.5547 19.37 22.3753 18.6427 21.648C17.9153 20.9207 16.736 20.9207 16.0087 21.648M16.0087 21.648L15.0053 22.6513"
        stroke={color}
        stroke-miterlimit="10"
      ></path>
      <path
        d="M33.1267 20.3313L26.1127 13.3173C25.6253 12.83 24.8353 12.83 24.348 13.3173L22.3747 15.2907C21.122 16.5433 19.198 16.7173 17.7593 15.8113C17.3873 15.5773 17.356 15.042 17.6667 14.7313L21.51 10.888L22.5967 9.80135L22.5913 9.79601C25.5007 6.88668 30.2167 6.88668 33.126 9.79601C36.0353 12.7053 36.0353 17.4213 33.126 20.3307L33.1267 20.3313Z"
        stroke={color}
        stroke-miterlimit="10"
      ></path>
    </svg>
  );
};

export default PXSvg;
